<div class="grid-x">
  <div class="cell large-12">
    <h3>Size and Depth</h3>
  </div>
</div>
@if (showEditWarning) {
  <div class="grid-x edit-warning padding-left padding-right margin-bottom">
    <div class="cell large-1">
      <svg-icon icon="icon-alert" class="small"></svg-icon>
    </div>
    <div class="cell large-11">
      Changing any values on this page will cause all subsequent strings to be deleted.
    </div>
  </div>
}
@if (validationErrors.length > 0) {
  <div class="grid-x validation margin-bottom">
    @for (error of validationErrors; track error) {
      <div class="cell large-12 padding-left">
        {{error}}
      </div>
    }
  </div>
}
<div class="grid-x">
  <div class="cell large-12">
    * Trailing decimals and trailing zeroes will be ignored.
  </div>
</div>
@if (wellSegment.casingType.definition === casingTypes.DrivePipe) {
  <div [formGroup]="formGroup" class="grid-x grid-margin-x">
    <div class="cell large-4">
      <label class="small-font-size" for="boreholeDiameter" [ngClass]="{ 'invalid-field': isInvalid('boreholeDiameter') }">Borehole Diameter (in) @if (isInvalid('boreholeDiameter')) {
        <span class="invalid-field">*</span>
      }</label>
      <input type="number" (wheel)="refocus()" formControlName="boreholeDiameter" id="boreholeDiameter" (blur)="validateForm()" (keypress)="preventEnter($event)" />
    </div>
    <div class="cell large-4">
      <label class="small-font-size" for="boreholeTop" [ngClass]="{ 'invalid-field': isInvalid('boreholeTop') }">
        Borehole Top (ft) @if (isInvalid('boreholeTop')) {
        <span class="invalid-field">*</span>
      }
    </label>
    <input type="number" (wheel)="refocus()" formControlName="boreholeTop" id="boreholeTop" (blur)="validateForm()" (keypress)="preventEnter($event)" />
  </div>
  <div class="cell large-4">
    <label class="small-font-size" for="boreholeBottom" [ngClass]="{ 'invalid-field': isInvalid('boreholeBottom') }">
      Borehole Bottom (ft) @if (isInvalid('boreholeBottom')) {
      <span class="invalid-field">*</span>
    }
  </label>
  <input type="number" (wheel)="refocus()" formControlName="boreholeBottom" id="boreholeBottom" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingDiameter" [ngClass]="{ 'invalid-field': isInvalid('casingDiameter') }">
    Casing Diameter (OD)(in) @if (isInvalid('casingDiameter')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingDiameter" id="casingDiameter" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingTop" [ngClass]="{ 'invalid-field': isInvalid('casingTop') }">
    Casing Top (ft) @if (isInvalid('casingTop')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingTop" id="casingTop" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingBottom" [ngClass]="{ 'invalid-field': isInvalid('casingBottom') }">
    Casing Bottom (ft) @if (isInvalid('casingBottom')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingBottom" id="casingBottom" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-6">
  <label class="small-font-size" for="casingGrade" [ngClass]="{ 'invalid-field': isInvalid('casingGrade') }">
    Casing Grade @if (isInvalid('casingGrade')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="text" formControlName="casingGrade" id="casingGrade" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell small-6">
  <label class="small-font-size" for="casingWeight" [ngClass]="{ 'invalid-field': isInvalid('casingWeight') }">
    Casing Weight (lbs/ft) @if (isInvalid('casingWeight')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingWeight" id="casingWeight" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
</div>
}
@if (wellSegment.casingType.definition === casingTypes.Conductor && wellSegment.drillingEquipment.definition === 'Concentric') {
  <div [formGroup]="formGroup" class="grid-x grid-margin-x">
    <div class="cell large-12">
      <label class="small-font-size" for="formation" [ngClass]="{ 'invalid-field': isInvalid('formation') }">Deepest Formation @if (isInvalid('formation')) {
        <span class="invalid-field">*</span>
      }</label>
      @if (availableFormations$) {
        <select id="formation" formControlName="formation" (change)="validateForm()" (keypress)="preventEnter($event)">
          @for (f of availableFormations$ | async; track f) {
            <option [ngValue]="f.code">{{f.definition}}</option>
          }
        </select>
      }
    </div>
    <div class="cell large-4">
      <label class="small-font-size" for="boreholeDiameter" [ngClass]="{ 'invalid-field': isInvalid('boreholeDiameter') }">Borehole Diameter (in) @if (isInvalid('boreholeDiameter')) {
        <span class="invalid-field">*</span>
      }</label>
      <input type="number" (wheel)="refocus()" formControlName="boreholeDiameter" id="boreholeDiameter" (blur)="validateForm()" (keypress)="preventEnter($event)" />
    </div>
    <div class="cell large-4">
      <label class="small-font-size" for="boreholeTop" [ngClass]="{ 'invalid-field': isInvalid('boreholeTop') }">
        Borehole Top (ft) @if (isInvalid('boreholeTop')) {
        <span class="invalid-field">*</span>
      }
    </label>
    <input type="number" (wheel)="refocus()" formControlName="boreholeTop" id="boreholeTop" (blur)="validateForm()" (keypress)="preventEnter($event)" />
  </div>
  <div class="cell large-4">
    <label class="small-font-size" for="boreholeBottom" [ngClass]="{ 'invalid-field': isInvalid('boreholeBottom') }">
      Borehole Bottom (ft) @if (isInvalid('boreholeBottom')) {
      <span class="invalid-field">*</span>
    }
  </label>
  <input type="number" (wheel)="refocus()" formControlName="boreholeBottom" id="boreholeBottom" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingDiameter" [ngClass]="{ 'invalid-field': isInvalid('casingDiameter') }">
    Casing Diameter (OD)(in) @if (isInvalid('casingDiameter')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingDiameter" id="casingDiameter" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingTop" [ngClass]="{ 'invalid-field': isInvalid('casingTop') }">
    Casing Top (ft) @if (isInvalid('casingTop')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingTop" id="casingTop" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingBottom" [ngClass]="{ 'invalid-field': isInvalid('casingBottom') }">
    Casing Bottom (ft) @if (isInvalid('casingBottom')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingBottom" id="casingBottom" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-6">
  <label class="small-font-size" for="casingGrade" [ngClass]="{ 'invalid-field': isInvalid('casingGrade') }">
    Casing Grade @if (isInvalid('casingGrade')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="text" formControlName="casingGrade" id="casingGrade" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell small-6">
  <label class="small-font-size" for="casingWeight" [ngClass]="{ 'invalid-field': isInvalid('casingWeight') }">
    Casing Weight (lbs/ft) @if (isInvalid('casingWeight')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingWeight" id="casingWeight" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
</div>
}
@if (wellSegment.casingType.definition === casingTypes.Surface || wellSegment.casingType.definition === casingTypes.MineString || (wellSegment.casingType.definition === casingTypes.Conductor && wellSegment.drillingEquipment.definition !== 'Concentric')) {
  <div [formGroup]="formGroup" class="grid-x grid-margin-x">
    <div class="cell large-12">
      <label class="small-font-size" for="formation" [ngClass]="{ 'invalid-field': isInvalid('formation') }">Deepest Formation @if (isInvalid('formation')) {
        <span class="invalid-field">*</span>
      }</label>
      @if (availableFormations$) {
        <select id="formation" formControlName="formation" (change)="validateForm()" (keypress)="preventEnter($event)">
          @for (f of availableFormations$ | async; track f) {
            <option [ngValue]="f.code">{{f.definition}}</option>
          }
        </select>
      }
    </div>
    <div class="cell large-4">
      <label class="small-font-size" for="boreholeDiameter" [ngClass]="{ 'invalid-field': isInvalid('boreholeDiameter') }">Borehole Diameter (in)  @if (isInvalid('boreholeDiameter')) {
        <span class="invalid-field">*</span>
      }</label>
      <input type="number" (wheel)="refocus()" formControlName="boreholeDiameter" id="boreholeDiameter" (blur)="validateForm()" (keypress)="preventEnter($event)" />
    </div>
    <div class="cell large-4">
      <label class="small-font-size" for="boreholeTop" [ngClass]="{ 'invalid-field': isInvalid('boreholeTop') }">
        Borehole Top (ft) @if (isInvalid('boreholeTop')) {
        <span class="invalid-field">*</span>
      }
    </label>
    <input type="number" (wheel)="refocus()" formControlName="boreholeTop" id="boreholeTop" (blur)="validateForm()" (keypress)="preventEnter($event)" />
  </div>
  <div class="cell large-4">
    <label class="small-font-size" for="boreholeBottom" [ngClass]="{ 'invalid-field': isInvalid('boreholeBottom') }">
      Borehole Bottom (ft) @if (isInvalid('boreholeBottom')) {
      <span class="invalid-field">*</span>
    }
  </label>
  <input type="number" (wheel)="refocus()" formControlName="boreholeBottom" id="boreholeBottom" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingDiameter" [ngClass]="{ 'invalid-field': isInvalid('casingDiameter') }">
    Casing Diameter (OD)(in) @if (isInvalid('casingDiameter')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingDiameter" id="casingDiameter" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingTop" [ngClass]="{ 'invalid-field': isInvalid('casingTop') }">
    Casing Top (ft) @if (isInvalid('casingTop')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingTop" id="casingTop" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingBottom" [ngClass]="{ 'invalid-field': isInvalid('casingBottom') }">
    Casing Bottom (ft) @if (isInvalid('casingBottom')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingBottom" id="casingBottom" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-6">
  <label class="small-font-size" for="casingGrade" [ngClass]="{ 'invalid-field': isInvalid('casingGrade') }">
    Casing Grade @if (isInvalid('casingGrade')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="text" formControlName="casingGrade" id="casingGrade" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-6">
  <label class="small-font-size" for="casingWeight" [ngClass]="{ 'invalid-field': isInvalid('casingWeight') }">
    Casing Weight (lbs/ft) @if (isInvalid('casingWeight')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingWeight" id="casingWeight" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingShoeDepth" [ngClass]="{ 'invalid-field': isInvalid('casingShoeDepth') }">
    Guide Shoe Length (ft) @if (isInvalid('casingShoeDepth')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingShoeDepth" id="casingShoeDepth" (blur)="calculateCement()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="numberCentralizers" [ngClass]="{ 'invalid-field': isInvalid('numberCentralizers') }">
    Number Centralizers @if (isInvalid('numberCentralizers')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="numberCentralizers" id="numberCentralizers" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="floatCollarDepth" [ngClass]="{ 'invalid-field': isInvalid('floatCollarDepth') }">
    Float Collar Depth (ft) @if (isInvalid('floatCollarDepth')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="floatCollarDepth" id="floatCollarDepth" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="basketDepth" [ngClass]="{ 'invalid-field': isInvalid('basketDepth') }">
    Basket Depth (ft) @if (isInvalid('basketDepth')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="basketDepth" id="basketDepth" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="packerDepth" [ngClass]="{ 'invalid-field': isInvalid('packerDepth') }">
    Packer Depth (ft) @if (isInvalid('packerDepth')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="packerDepth" id="packerDepth" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="dvToolDepth" [ngClass]="{ 'invalid-field': isInvalid('dvToolDepth') }">
    Deviation Tool Depth (ft) @if (isInvalid('dvToolDepth')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="dvToolDepth" id="dvToolDepth" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-6">
  <label class="small-font-size" for="cementTop" [ngClass]="{ 'invalid-field': isInvalid('cementTop') }">
    Cement Top (ft) @if (isInvalid('cementTop')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="cementTop" id="cementTop" (blur)="calculateCement()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-6">
  <label class="small-font-size" for="cementBottom" [ngClass]="{ 'invalid-field': isInvalid('cementBottom') }">
    Cement Bottom @if (isInvalid('cementBottom')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="cementBottom" id="cementBottom" (blur)="calculateCement()" (keypress)="preventEnter($event)" />
</div>
</div>
}
@if (wellSegment.casingType.definition === casingTypes.Intermediate1 || wellSegment.casingType.definition === casingTypes.Intermediate2) {
  <div [formGroup]="formGroup" class="grid-x grid-margin-x">
    @if (wellSegment.drillingEquipment.definition.toLowerCase() === 'cable') {
      <div class="cell large-12">
        <label class="small-font-size" for="toBePulled" [ngClass]="{ 'invalid-field': isInvalid('toBePulled') }">Will this string be pulled? @if (isInvalid('toBePulled')) {
          <span class="invalid-field">*</span>
        }</label>
        <select id="toBePulled" formControlName="toBePulled" (change)="validateForm()" (keypress)="preventEnter($event)">
          <option [ngValue]="true" selected="selected">Yes</option>
          <option [ngValue]="false">No</option>
        </select>
      </div>
    }
    <div class="cell large-12">
      <label class="small-font-size" for="zoneTested" [ngClass]="{ 'invalid-field': isInvalid('zoneTested') }">Zone Tested or Produced @if (isInvalid('zoneTested')) {
        <span class="invalid-field">*</span>
      }</label>
      <select id="zoneTested" formControlName="zoneTested" (change)="validateForm()" (keypress)="preventEnter($event)">
        <option [ngValue]="true" selected="selected">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
    </div>
    <div class="cell large-12">
      <label class="small-font-size" for="formation" [ngClass]="{ 'invalid-field': isInvalid('formation') }">Deepest Formation @if (isInvalid('formation')) {
        <span class="invalid-field">*</span>
      }</label>
      @if (availableFormations$) {
        <select id="formation" formControlName="formation" (change)="validateForm()" (keypress)="preventEnter($event)">
          @for (f of availableFormations$ | async; track f) {
            <option [ngValue]="f.code">{{f.definition}}</option>
          }
        </select>
      }
    </div>
    <div class="cell large-4">
      <label class="small-font-size" for="boreholeDiameter" [ngClass]="{ 'invalid-field': isInvalid('boreholeDiameter') }">Borehole Diameter (in) @if (isInvalid('boreholeDiameter')) {
        <span class="invalid-field">*</span>
      }</label>
      <input type="number" (wheel)="refocus()" formControlName="boreholeDiameter" id="boreholeDiameter" (blur)="validateForm()" (keypress)="preventEnter($event)" />
    </div>
    <div class="cell large-4">
      <label class="small-font-size" for="boreholeTop" [ngClass]="{ 'invalid-field': isInvalid('boreholeTop') }">
        Borehole Top (ft) @if (isInvalid('boreholeTop')) {
        <span class="invalid-field">*</span>
      }
    </label>
    <input type="number" (wheel)="refocus()" formControlName="boreholeTop" id="boreholeTop" (blur)="validateForm()" (keypress)="preventEnter($event)" />
  </div>
  <div class="cell large-4">
    <label class="small-font-size" for="boreholeBottom" [ngClass]="{ 'invalid-field': isInvalid('boreholeBottom') }">
      Borehole Bottom (ft) @if (isInvalid('boreholeBottom')) {
      <span class="invalid-field">*</span>
    }
  </label>
  <input type="number" (wheel)="refocus()" formControlName="boreholeBottom" id="boreholeBottom" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingDiameter" [ngClass]="{ 'invalid-field': isInvalid('casingDiameter') }">
    Casing Diameter (OD)(in) @if (isInvalid('casingDiameter')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingDiameter" id="casingDiameter" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingTop" [ngClass]="{ 'invalid-field': isInvalid('casingTop') }">
    Casing Top (ft) @if (isInvalid('casingTop')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingTop" id="casingTop" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingBottom" [ngClass]="{ 'invalid-field': isInvalid('casingBottom') }">
    Casing Bottom (ft) @if (isInvalid('casingBottom')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingBottom" id="casingBottom" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-6">
  <label class="small-font-size" for="casingGrade" [ngClass]="{ 'invalid-field': isInvalid('casingGrade') }">
    Casing Grade @if (isInvalid('casingGrade')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="text" formControlName="casingGrade" id="casingGrade" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-6">
  <label class="small-font-size" for="casingWeight" [ngClass]="{ 'invalid-field': isInvalid('casingWeight') }">
    Casing Weight (lbs/ft) @if (isInvalid('casingWeight')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingWeight" id="casingWeight" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingShoeDepth" [ngClass]="{ 'invalid-field': isInvalid('casingShoeDepth') }">
    Guide Shoe Length (ft) @if (isInvalid('casingShoeDepth')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingShoeDepth" id="casingShoeDepth" (blur)="calculateCement()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="numberCentralizers" [ngClass]="{ 'invalid-field': isInvalid('numberCentralizers') }">
    Number Centralizers @if (isInvalid('numberCentralizers')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="numberCentralizers" id="numberCentralizers" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="floatCollarDepth" [ngClass]="{ 'invalid-field': isInvalid('floatCollarDepth') }">
    Float Collar Depth (ft) @if (isInvalid('floatCollarDepth')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="floatCollarDepth" id="floatCollarDepth" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="basketDepth" [ngClass]="{ 'invalid-field': isInvalid('basketDepth') }">
    Basket Depth (ft) @if (isInvalid('basketDepth')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="basketDepth" id="basketDepth" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="packerDepth" [ngClass]="{ 'invalid-field': isInvalid('packerDepth') }">
    Packer Depth (ft) @if (isInvalid('packerDepth')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="packerDepth" id="packerDepth" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="dvToolDepth" [ngClass]="{ 'invalid-field': isInvalid('dvToolDepth') }">
    Deviation Tool Depth (ft) @if (isInvalid('dvToolDepth')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="dvToolDepth" id="dvToolDepth" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-6">
  <label class="small-font-size" for="cementTop" [ngClass]="{ 'invalid-field': isInvalid('cementTop') }">
    Cement Top (ft) @if (isInvalid('cementTop')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="cementTop" id="cementTop" (blur)="calculateCement()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-6">
  <label class="small-font-size" for="cementBottom" [ngClass]="{ 'invalid-field': isInvalid('cementBottom') }">
    Cement Bottom @if (isInvalid('cementBottom')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="cementBottom" id="cementBottom" (blur)="calculateCement()" (keypress)="preventEnter($event)" />
</div>
</div>
}
@if (wellSegment.casingType.definition === casingTypes.Production) {
  <div [formGroup]="formGroup" class="grid-x grid-margin-x">
    <div class="cell large-12">
      <label class="small-font-size" for="zoneTested" [ngClass]="{ 'invalid-field': isInvalid('zoneTested') }">Zone Tested or Produced @if (isInvalid('zoneTested')) {
        <span class="invalid-field">*</span>
      }</label>
      <select id="zoneTested" formControlName="zoneTested" (change)="validateForm()" (keypress)="preventEnter($event)">
        <option [ngValue]="true" selected="selected">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
    </div>
    <div class="cell large-12">
      <label class="small-font-size" for="hydFrac" [ngClass]="{ 'invalid-field': isInvalid('hydraulicFracturing') }">Hydraulically Fractured @if (isInvalid('hydraulicFracturing')) {
        <span class="invalid-field">*</span>
      }</label>
      <select id="hydFrac" formControlName="hydraulicFracturing" (change)="validateForm()" (keypress)="preventEnter($event)">
        <option [ngValue]="true" selected="selected">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
    </div>
    <div class="cell large-12">
      <label class="small-font-size" for="formation" [ngClass]="{ 'invalid-field': isInvalid('formation') }">Deepest Formation @if (isInvalid('formation')) {
        <span class="invalid-field">*</span>
      }</label>
      @if (availableFormations$) {
        <select id="formation" formControlName="formation" (change)="validateForm()" (keypress)="preventEnter($event)">
          @for (f of availableFormations$ | async; track f) {
            <option [ngValue]="f.code">{{f.definition}}</option>
          }
        </select>
      }
    </div>
    <div class="cell large-4">
      <label class="small-font-size" for="boreholeDiameter" [ngClass]="{ 'invalid-field': isInvalid('boreholeDiameter') }">Borehole Diameter (in) @if (isInvalid('boreholeDiameter')) {
        <span class="invalid-field">*</span>
      }</label>
      <input type="number" (wheel)="refocus()" formControlName="boreholeDiameter" id="boreholeDiameter" (blur)="validateForm()" (keypress)="preventEnter($event)" />
    </div>
    <div class="cell large-4">
      <label class="small-font-size" for="boreholeTop" [ngClass]="{ 'invalid-field': isInvalid('boreholeTop') }">
        Borehole Top (ft) @if (isInvalid('boreholeTop')) {
        <span class="invalid-field">*</span>
      }
    </label>
    <input type="number" (wheel)="refocus()" formControlName="boreholeTop" id="boreholeTop" (blur)="validateForm()" (keypress)="preventEnter($event)" />
  </div>
  <div class="cell large-4">
    <label class="small-font-size" for="boreholeBottom" [ngClass]="{ 'invalid-field': isInvalid('boreholeBottom') }">
      Borehole Bottom (ft) @if (isInvalid('boreholeBottom')) {
      <span class="invalid-field">*</span>
    }
  </label>
  <input type="number" (wheel)="refocus()" formControlName="boreholeBottom" id="boreholeBottom" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingDiameter" [ngClass]="{ 'invalid-field': isInvalid('casingDiameter') }">
    Casing Diameter (OD)(in) @if (isInvalid('casingDiameter')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingDiameter" id="casingDiameter" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingTop" [ngClass]="{ 'invalid-field': isInvalid('casingTop') }">
    Casing Top (ft) @if (isInvalid('casingTop')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingTop" id="casingTop" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingBottom" [ngClass]="{ 'invalid-field': isInvalid('casingBottom') }">
    Casing Bottom (ft) @if (isInvalid('casingBottom')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingBottom" id="casingBottom" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-6">
  <label class="small-font-size" for="casingGrade" [ngClass]="{ 'invalid-field': isInvalid('casingGrade') }">
    Casing Grade @if (isInvalid('casingGrade')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="text" formControlName="casingGrade" id="casingGrade" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-6">
  <label class="small-font-size" for="casingWeight" [ngClass]="{ 'invalid-field': isInvalid('casingWeight') }">
    Casing Weight (lbs/ft) @if (isInvalid('casingWeight')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingWeight" id="casingWeight" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingShoeDepth" [ngClass]="{ 'invalid-field': isInvalid('casingShoeDepth') }">
    Guide Shoe Length (ft) @if (isInvalid('casingShoeDepth')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingShoeDepth" id="casingShoeDepth" (blur)="calculateCement()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="numberCentralizers" [ngClass]="{ 'invalid-field': isInvalid('numberCentralizers') }">
    Number Centralizers @if (isInvalid('numberCentralizers')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="numberCentralizers" id="numberCentralizers" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="floatCollarDepth" [ngClass]="{ 'invalid-field': isInvalid('floatCollarDepth') }">
    Float Collar Depth (ft) @if (isInvalid('floatCollarDepth')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="floatCollarDepth" id="floatCollarDepth" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="basketDepth" [ngClass]="{ 'invalid-field': isInvalid('basketDepth') }">
    Basket Depth (ft) @if (isInvalid('basketDepth')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="basketDepth" id="basketDepth" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="packerDepth" [ngClass]="{ 'invalid-field': isInvalid('packerDepth') }">
    Packer Depth (ft) @if (isInvalid('packerDepth')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="packerDepth" id="packerDepth" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="dvToolDepth" [ngClass]="{ 'invalid-field': isInvalid('dvToolDepth') }">
    Deviation Tool Depth (ft) @if (isInvalid('dvToolDepth')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="dvToolDepth" id="dvToolDepth" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-6">
  <label class="small-font-size" for="perforationTop" [ngClass]="{ 'invalid-field': isInvalid('perforationTop') }">
    Perforation Top (ft) @if (isInvalid('perforationTop')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="perforationTop" id="perforationTop" (blur)="calculateCement()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-6">
  <label class="small-font-size" for="perforationBottom" [ngClass]="{ 'invalid-field': isInvalid('perforationBottom') }">
    Perforation Bottom @if (isInvalid('perforationBottom')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="perforationBottom" id="perforationBottom" (blur)="calculateCement()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="shotsPerStage" [ngClass]="{ 'invalid-field': isInvalid('shotsPerStage') }">
    Shots Per Stage @if (isInvalid('shotsPerStage')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="shotsPerStage" id="shotsPerStage" (keypress)="preventEnter($event)" />
</div>
@switch (wellDirection) {
  @case (wellDirections.Vertical) {
    <div class="cell large-4">
      <label class="small-font-size" for="stageNumber" [ngClass]="{ 'invalid-field': isInvalid('stageNumber') }">
        Stage Number @if (isInvalid('stageNumber')) {
        <span class="invalid-field">*</span>
      }
    </label>
    <input type="number" (wheel)="refocus()" formControlName="stageNumber" id="stageNumber" (keypress)="preventEnter($event)" />
  </div>
  <div class="cell large-4">&nbsp;</div>
}
@case (wellDirections.Horizontal) {
  <div class="cell large-4">
    <label class="small-font-size" for="numberOfStages" [ngClass]="{ 'invalid-field': isInvalid('numberOfStages') }">
      Number of Stages @if (isInvalid('numberOfStages')) {
      <span class="invalid-field">*</span>
    }
  </label>
  <input type="number" (wheel)="refocus()" formControlName="numberOfStages" id="numberOfStages" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">&nbsp;</div>
}
@case (wellDirections.OtherHorizontal) {
  <div class="cell large-4">
    <label class="small-font-size" for="numberOfStages" [ngClass]="{ 'invalid-field': isInvalid('numberOfStages') }">
      Number of Stages @if (isInvalid('numberOfStages')) {
      <span class="invalid-field">*</span>
    }
  </label>
  <input type="number" (wheel)="refocus()" formControlName="numberOfStages" id="numberOfStages" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">&nbsp;</div>
}
@default {
  <div class="cell large-8">
    &nbsp;
  </div>
}
}
<div class="cell large-6">
  <label class="small-font-size" for="cementTop" [ngClass]="{ 'invalid-field': isInvalid('cementTop') }">
    Cement Top (ft) @if (isInvalid('cementTop')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="cementTop" id="cementTop" (blur)="calculateCement()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-6">
  <label class="small-font-size" for="cementBottom" [ngClass]="{ 'invalid-field': isInvalid('cementBottom') }">
    Cement Bottom @if (isInvalid('cementBottom')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="cementBottom" id="cementBottom" (blur)="calculateCement()" (keypress)="preventEnter($event)" />
</div>
</div>
}
@if (wellSegment.casingType.definition === casingTypes.OpenHole) {
  <div [formGroup]="formGroup" class="grid-x grid-margin-x">
    <div class="cell large-12">
      <a href="https://www.glossary.oilfield.slb.com/en/Terms/o/openhole_completion.aspx">http://www.glossary.oilfield.slb.com/en/Terms/o/openhole_completion.aspx</a>
    </div>
    <div class="cell large-12">
      <label class="small-font-size" for="zoneTested" [ngClass]="{ 'invalid-field': isInvalid('zoneTested') }">Zone Tested or Produced @if (isInvalid('zoneTested')) {
        <span class="invalid-field">*</span>
      }</label>
      <select id="zoneTested" formControlName="zoneTested" (blur)="validateForm()" (keypress)="preventEnter($event)">
        <option [ngValue]="true" selected="selected">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
    </div>
    <div class="cell large-12">
      <label class="small-font-size" for="hydFrac" [ngClass]="{ 'invalid-field': isInvalid('hydraulicFracturing') }">Hydraulically Fractured @if (isInvalid('hydraulicFracturing')) {
        <span class="invalid-field">*</span>
      }</label>
      <select id="hydFrac" formControlName="hydraulicFracturing" (blur)="validateForm()" (keypress)="preventEnter($event)">
        <option [ngValue]="true" selected="selected">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
    </div>
    <div class="cell large-12">
      <label class="small-font-size" for="formation" [ngClass]="{ 'invalid-field': isInvalid('formation') }">Deepest Formation @if (isInvalid('formation')) {
        <span class="invalid-field">*</span>
      }</label>
      @if (availableFormations$) {
        <select id="formation" formControlName="formation" (change)="validateForm()" (keypress)="preventEnter($event)">
          @for (f of availableFormations$ | async; track f) {
            <option [ngValue]="f.code">{{f.definition}}</option>
          }
        </select>
      }
    </div>
    <div class="cell large-4">
      <label class="small-font-size" for="boreholeDiameter" [ngClass]="{ 'invalid-field': isInvalid('boreholeDiameter') }">Borehole Diameter (in) @if (isInvalid('boreholeDiameter')) {
        <span class="invalid-field">*</span>
      }</label>
      <input type="number" (wheel)="refocus()" formControlName="boreholeDiameter" id="boreholeDiameter" (blur)="validateForm()" (keypress)="preventEnter($event)" />
    </div>
    <div class="cell large-4">
      <label class="small-font-size" for="boreholeTop" [ngClass]="{ 'invalid-field': isInvalid('boreholeTop') }">
        Borehole Top (ft) @if (isInvalid('boreholeTop')) {
        <span class="invalid-field">*</span>
      }
    </label>
    <input type="number" (wheel)="refocus()" formControlName="boreholeTop" id="boreholeTop" (blur)="validateForm()" (keypress)="preventEnter($event)" />
  </div>
  <div class="cell large-4">
    <label class="small-font-size" for="boreholeBottom" [ngClass]="{ 'invalid-field': isInvalid('boreholeBottom') }">
      Borehole Bottom (ft) @if (isInvalid('boreholeBottom')) {
      <span class="invalid-field">*</span>
    }
  </label>
  <input type="number" (wheel)="refocus()" formControlName="boreholeBottom" id="boreholeBottom" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
</div>
}
@if (wellSegment.casingType.definition === casingTypes.Liner1) {
  <div [formGroup]="formGroup" class="cell grid-x grid-margin-x">
    <div class="cell large-12">
      <label class="small-font-size" for="zoneTested" [ngClass]="{ 'invalid-field': isInvalid('zoneTested') }">Zone Tested or Produced @if (isInvalid('zoneTested')) {
        <span class="invalid-field">*</span>
      }</label>
      <select id="zoneTested" formControlName="zoneTested" (change)="validateForm()" (keypress)="preventEnter($event)">
        <option [ngValue]="true" selected="selected">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
    </div>
    <div class="cell large-12">
      <label class="small-font-size" for="hydFrac" [ngClass]="{ 'invalid-field': isInvalid('hydraulicFracturing') }">Hydraulically Fractured @if (isInvalid('hydraulicFracturing')) {
        <span class="invalid-field">*</span>
      }</label>
      <select id="hydFrac" formControlName="hydraulicFracturing" (change)="validateForm()" (keypress)="preventEnter($event)">
        <option [ngValue]="true" selected="selected">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
    </div>
    <div class="cell large-12">
      <label class="small-font-size" for="formation" [ngClass]="{ 'invalid-field': isInvalid('formation') }">Deepest Formation @if (isInvalid('formation')) {
        <span class="invalid-field">*</span>
      }</label>
      @if (availableFormations$) {
        <select id="formation" formControlName="formation" (change)="validateForm()" (keypress)="preventEnter($event)">
          @for (f of availableFormations$ | async; track f) {
            <option [ngValue]="f.code">{{f.definition}}</option>
          }
        </select>
      }
    </div>
    <div class="cell large-4">
      <label class="small-font-size" for="boreholeTop" [ngClass]="{ 'invalid-field': isInvalid('boreholeTop') }">
        Borehole Top (ft) @if (isInvalid('boreholeTop')) {
        <span class="invalid-field">*</span>
      }
    </label>
    <input type="number" (wheel)="refocus()" formControlName="boreholeTop" id="boreholeTop" (blur)="validateForm()" (keypress)="preventEnter($event)" />
  </div>
  <div class="cell large-4">
    <label class="small-font-size" for="boreholeBottom" [ngClass]="{ 'invalid-field': isInvalid('boreholeBottom') }">
      Borehole Bottom (ft) @if (isInvalid('boreholeBottom')) {
      <span class="invalid-field">*</span>
    }
  </label>
  <input type="number" (wheel)="refocus()" formControlName="boreholeBottom" id="boreholeBottom" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingDiameter" [ngClass]="{ 'invalid-field': isInvalid('casingDiameter') }">
    Casing Diameter (OD)(in) @if (isInvalid('casingDiameter')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingDiameter" id="casingDiameter" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingTop" [ngClass]="{ 'invalid-field': isInvalid('casingTop') }">
    Casing Top (ft) @if (isInvalid('casingTop')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingTop" id="casingTop" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="casingBottom" [ngClass]="{ 'invalid-field': isInvalid('casingBottom') }">
    Casing Bottom (ft) @if (isInvalid('casingBottom')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="casingBottom" id="casingBottom" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="boreholeDiameter" [ngClass]="{ 'invalid-field': isInvalid('boreholeDiameter') }">Borehole Diameter (in) @if (isInvalid('boreholeDiameter')) {
    <span class="invalid-field">*</span>
  }</label>
  <input type="number" (wheel)="refocus()" formControlName="boreholeDiameter" id="boreholeDiameter" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
</div>
}
@if (wellSegment.casingType.definition === casingTypes.Tubing) {
  <div [formGroup]="formGroup" class="cell grid-x grid-margin-x">
    <div class="cell large-12">
      <label class="small-font-size" for="zoneTested" [ngClass]="{ 'invalid-field': isInvalid('zoneTested') }">Zone Tested or Produced @if (isInvalid('zoneTested')) {
        <span class="invalid-field">*</span>
      }</label>
      <select id="zoneTested" formControlName="zoneTested" (change)="validateForm()" (keypress)="preventEnter($event)">
        <option [ngValue]="true" selected="selected">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
    </div>
    <div class="cell large-12">
      <label class="small-font-size" for="hydFrac" [ngClass]="{ 'invalid-field': isInvalid('hydraulicFracturing') }">Hydraulically Fractured @if (isInvalid('hydraulicFracturing')) {
        <span class="invalid-field">*</span>
      }</label>
      <select id="hydFrac" formControlName="hydraulicFracturing" (change)="validateForm()" (keypress)="preventEnter($event)">
        <option [ngValue]="true" selected="selected">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
    </div>
    <div class="cell large-4">
      <label class="small-font-size" for="tubingDiameter" [ngClass]="{ 'invalid-field': isInvalid('tubingDiameter') }">
        Tubing Diameter (OD)(in) @if (isInvalid('tubingDiameter')) {
        <span class="invalid-field">*</span>
      }
    </label>
    <input type="number" (wheel)="refocus()" formControlName="tubingDiameter" id="tubingDiameter" (blur)="validateForm()" (keypress)="preventEnter($event)" />
  </div>
  <div class="cell large-4">
    <label class="small-font-size" for="tubingLength" [ngClass]="{ 'invalid-field': isInvalid('tubingLength') }">
      Tubing Length (ft) @if (isInvalid('tubingLength')) {
      <span class="invalid-field">*</span>
    }
  </label>
  <input type="number" (wheel)="refocus()" formControlName="tubingLength" id="tubingLength" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large-4">
  <label class="small-font-size" for="packerDepth" [ngClass]="{ 'invalid-field': isInvalid('packerDepth') }">
    Packer Depth (ft) @if (isInvalid('packerDepth')) {
    <span class="invalid-field">*</span>
  }
</label>
<input type="number" (wheel)="refocus()" formControlName="packerDepth" id="packerDepth" (blur)="validateForm()" (keypress)="preventEnter($event)" />
</div>
<div class="cell large=8">&nbsp;</div>
</div>
}
@if (showCementCalculations) {
  <div class="cementFieldset" [formGroup]="formGroup">
    <label class="small-font-size bold">Cement</label>
    <div>
      <label class="small-font-size">Based on your entries above, this is your estimated requirement for cement sacks required.</label>
    </div>
    <div class="cell auto">
      <label class="small-font-size">Cement Class</label>
      <input type="text" formControlName="cementClass" />
    </div>
    <div class="cell auto">
      <label class="small-font-size">Slurry Yield (cubic ft/sk)</label>
      <input type="number" formControlName="slurryYield" />
    </div>
    <div class="cell auto">
      <label class="small-font-size">Cement Sacks</label>
      <input type="number" formControlName="cementVolume" id="cementVolume" />
      @if (extraProductionCalculation) {
        <div>This calculation includes the previous Intermediate String to be pulled</div>
      }
    </div>
  </div>
  <div class="small-font-size">
    The responsibilities for verification of accuracy of cement used in design remains with the engineer of record.
    Calculations should be considered estimates based on best conditions and may not accurately predict real world conditions
    and should only be used as approximations and assumptions to the requirements of well construction. Accordingly, DOGRM
    does and must disclaim any and all responsibility for deficiencies or failures of connection with which these calculated approximations are used.
  </div>
}
